module.exports = __webpack_public_path__ + "static/estate-planning-hero-desktop.a4f94ea2.webp";